export type PackageSortProperty = Paths.ApiDocumentPackagetosign.Get.Parameters.SortProperty;

export const defaultPackagePagination = { result: [] as MyBrokerApi.DocumentsPackageToSign[], total: 0 };
